// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes EZffZ{from{opacity:0}to{opacity:1}}@keyframes Yz8u9{from{transform:translateY(8px)}to{transform:translateY(0)}}.chJO3{padding-inline:8px}.xcico{animation:EZffZ 280ms cubic-bezier(0.22, 1, 0.36, 1) 340ms both}.LVSkq{animation:O91iJ 280ms cubic-bezier(0.22, 1, 0.36, 1) 340ms both}@keyframes O91iJ{from{transform:translateY(8px)}to{transform:translateY(0)}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `chJO3`,
	"justResolvedEnter": `xcico`,
	"chat-fade-in": `EZffZ`,
	"justResolvedBubbleSlide": `LVSkq`,
	"recap-bubble-slide": `O91iJ`,
	"chat-slot-card-enter": `Yz8u9`
};
export default ___CSS_LOADER_EXPORT___;
